/**
 * 요건 텍스트 정렬 — 번호 조항(1./2.)·● 불릿을 각 줄로 분리.
 * 세번상세(HskDetailPanel.ReqGroup)와 통관정보(ReqGuidePage.HskReqDetail) 공용.
 *   - 숫자 절: 앞 공백이 있는 "1. "만 분리(소수 2009.4·천단위 1,000 오분리 방지)
 *   - ● 불릿: 각 항목을 새 줄로
 * 61차(2026-09-16): 줄 안의 `[법령명]`·`법령명 제N조`·`별표 N`을 근거 화면으로 잇는다(`reqLinks.linkifyReqLine`).
 */
import { linkifyReqLine } from "./reqLinks";

export function formatReqLines(text) {
  if (!text) return [];
  let t = String(text).replace(/\r/g, " ");
  t = t.replace(/\s+([1-9])\.\s+/g, "\n$1. "); // 숫자 절(앞 공백 필요)
  t = t.replace(/\s*●\s*/g, "\n● "); // ● 불릿
  return t
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
}

/**
 * 정렬된 요건 텍스트 블록 — ● 불릿은 hanging indent 로 정렬.
 * laws: 이 항목의 법령명 목록(agencies[].law) — 본문 안 법령·조문·별표 링크의 기준.
 */
/**
 * 이어진 ● 불릿 줄을 한 묶음으로 모은다 — [{ bullets: [...] } | { line }].
 * 세관장확인 대상 품목처럼 불릿이 수십 개면 한 줄씩 세우지 않고 가로로 잇는다(문의 #111).
 */
export function groupBulletRuns(lines) {
  const out = [];
  lines.forEach((ln) => {
    if (ln.startsWith("●")) {
      const item = ln.replace(/^●\s*/, "");
      if (!item) return;
      const last = out[out.length - 1];
      if (last && last.bullets) last.bullets.push(item);
      else out.push({ bullets: [item] });
    } else {
      out.push({ line: ln });
    }
  });
  return out;
}

export function ReqLines({ text, style, laws, inlineBullets = false }) {
  const lines = formatReqLines(text);
  if (!lines.length) return null;
  const ctx = { laws: Array.isArray(laws) ? laws : [] };
  if (inlineBullets) {
    return (
      <div style={style}>
        {groupBulletRuns(lines).map((g, j) =>
          g.bullets ? (
            <div key={j} data-testid="req-bullet-run" style={{ marginTop: j ? 3 : 0 }}>
              {g.bullets.map((b, k) => (
                <span key={k} style={{ marginRight: 10, display: "inline-block" }}>
                  ● {linkifyReqLine(b, ctx)}
                </span>
              ))}
            </div>
          ) : (
            <div key={j} style={{ marginTop: j ? 3 : 0 }}>
              {linkifyReqLine(g.line, ctx)}
            </div>
          ),
        )}
      </div>
    );
  }
  return (
    <div style={style}>
      {lines.map((ln, j) => {
        const bullet = ln.startsWith("●");
        return (
          <div
            key={j}
            style={{
              marginTop: j ? 3 : 0,
              paddingLeft: bullet ? 14 : 0,
              textIndent: bullet ? -14 : 0,
            }}
          >
            {linkifyReqLine(ln, ctx)}
          </div>
        );
      })}
    </div>
  );
}
